// extracted by mini-css-extract-plugin
module.exports = {"status":"course-block_status__IPyLt","list":"course-block_list__2SyyX"};